module.exports = __webpack_public_path__ + "static/media/hero.5f4fb6d2.jpeg";